<template>
  <div>
    <router-link :to="url">
      <img :src="preview" alt="" class="object-cover " />
    </router-link>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "SessionGridItem",
  props: {
    session: {
      type: Object
    }
  },
  computed: {
    url() {
      return `/session/${this.session.slug.current}`;
    },
    preview() {
      return sanityImageBuilder
        .image(this.session.previewImage)
        .width(300)
        .height(300)
        .url();
    }
  }
};
</script>

<style scoped></style>
